import React, { useEffect, useState } from 'react';
import { CheckCircle2, X } from 'lucide-react';
import { getRandomPurchaser } from '../utils/popupData';
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [purchaser, setPurchaser] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showPopup();
    }, 5000);
    const showPopup = () => {
      setPurchaser(getRandomPurchaser());
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Repeat every 12 seconds
    const interval = setInterval(() => {
      showPopup();
    }, 12000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 right-4 z-50 animate-in slide-in-from-bottom-5 fade-in duration-500" data-id="element-121">
      <div className="bg-white rounded-lg shadow-xl border border-slate-100 p-4 max-w-sm flex items-start gap-3 relative" data-id="element-122">
        <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-slate-400 hover:text-slate-600" data-id="element-123">
          <X size={14} data-id="element-124" />
        </button>

        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-125">
          <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-126" />
        </div>

        <div data-id="element-127">
          <p className="text-sm font-medium text-slate-900" data-id="element-128">
            {purchaser.name} de {purchaser.city}
          </p>
          <p className="text-xs text-slate-500 mt-1" data-id="element-129">
            acaba de adquirir el Mega Pack de Dislexia
          </p>
          <p className="text-xs text-teal-600 font-medium mt-1" data-id="element-130">
            Hace unos instantes
          </p>
        </div>
      </div>
    </div>;
}